/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPatientProcedure } from 'app/shared/model/patient-procedure.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { IVitals } from 'app/shared/model/vitals.model';
import { INurse } from 'app/shared/model/nurse.model';
import { TypeOfAnaesthesia } from 'app/shared/model/enumerations/type-of-anaesthesia.model';
import { Induction } from 'app/shared/model/enumerations/induction.model';
import { OPInhalational } from 'app/shared/model/enumerations/op-inhalational.model';
import { OPEtube } from 'app/shared/model/enumerations/op-etube.model';
import { OPVentilation } from 'app/shared/model/enumerations/op-ventilation.model';
import { Spontaneous } from 'app/shared/model/enumerations/spontaneous.model';
import { PatientPosition } from 'app/shared/model/enumerations/patient-position.model';

export interface IPreOpAnaesthesiaChart {
  id?: string;
  typeOfAnaesthesia?: keyof typeof TypeOfAnaesthesia | null;
  generalCondition?: string | null;
  ivAccess?: string | null;
  site?: string | null;
  cannulaGuage?: string | null;
  raTechnique?: string | null;
  raApproach?: string | null;
  raNeedle?: string | null;
  raSpace?: string | null;
  raDrug?: string | null;
  raOnsetAction?: string | null;
  raSensoryLevel?: string | null;
  raMotorLevel?: string | null;
  gaPreOxygenation?: string | null;
  induction?: keyof typeof Induction | null;
  inhalational?: keyof typeof OPInhalational | null;
  etube?: keyof typeof OPEtube | null;
  etSize?: string | null;
  etCuff?: string | null;
  etOtherInfo?: string | null;
  ventilation?: keyof typeof OPVentilation | null;
  spontaneous?: keyof typeof Spontaneous | null;
  ventilatorMv?: string | null;
  ventilatorRr?: string | null;
  ventilatorTv?: string | null;
  ventilatorIvRatio?: string | null;
  patientPosition?: keyof typeof PatientPosition | null;
  torniquetAppliedAt?: number | null;
  torniquetRemovedAt?: number | null;
  timeOfInduction?: number | null;
  timeOfIndcision?: number | null;
  timeOfSurgeyCompletion?: number | null;
  timeOfExtubation?: number | null;
  additionalNotes?: string | null;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  surgery?: IPatientProcedure;
  anaesthesiologist?: IDoctor;
  vitals?: IVitals;
  nurse?: INurse | null;
}

export const defaultValue: Readonly<IPreOpAnaesthesiaChart> = {
  active: false,
};
